// @flow
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

const fbProvider = new firebase.auth.FacebookAuthProvider()

const config = {
  apiKey: 'AIzaSyC8G8oNxUEU6OD7E7VnCT26b4rCVPk8n4w',
  authDomain: 'mumu-auth-test.firebaseapp.com',
  databaseURL: 'https://mumu-auth-test.firebaseio.com',
  projectId: 'mumu-auth-test',
  storageBucket: 'mumu-auth-test.appspot.com',
  messagingSenderId: '41544346365',
}

let recordDataconfig
if (process.env.NODE_ENV === 'production') {
  recordDataconfig = {
    apiKey: 'AIzaSyBFnFy6j5XFUpepAKB10oFxGO3uncu5XHk',
    authDomain: 'zoetis-goodbyeitch-dev.firebaseapp.com',
    databaseURL: 'https://zoetis-goodbyeitch-dev.firebaseio.com',
    projectId: 'zoetis-goodbyeitch-dev',
  }
} else {
  recordDataconfig = {
    apiKey: 'AIzaSyBFnFy6j5XFUpepAKB10oFxGO3uncu5XHk',
    authDomain: 'zoetis-goodbyeitch-dev.firebaseapp.com',
    databaseURL: 'https://zoetis-goodbyeitch-dev.firebaseio.com',
    projectId: 'zoetis-goodbyeitch-dev',
  }
}


firebase.initializeApp(config)

export function signInWithFacebook(): void {
  firebase.auth().signInWithRedirect(fbProvider)
}

export async function signIn(
  username: string,
  password: string,
): Promise<User> {
  return firebase.auth().signInWithEmailAndPassword(username, password)
}
var secondary = firebase.initializeApp(recordDataconfig, "secondary");
console.log("secondary", secondary)
var secondaryDatabase = secondary.firestore();

export const db = secondaryDatabase
